import { ProductEnvironment } from '@atlassian/forge-ui/provider';

export const getProductEnvironment = (environment): ProductEnvironment => {
	return window.location.hostname === 'localhost'
		? // In dev, proxying to a site will give that site's environment,
			// which is not what we want
			ProductEnvironment.DEVELOPMENT
		: environment === 'STAGING'
			? ProductEnvironment.STAGING
			: environment === 'PRODUCTION'
				? ProductEnvironment.PRODUCTION
				: ProductEnvironment.DEVELOPMENT;
};
